import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HotelBrandComponent } from './hotel-brand/hotel-brand.component';
import { HotelsListComponent } from './hotels-list/hotels-list.component';
import { HotelBrandAddComponent } from './hotel-brand-add/hotel-brand-add.component';
import { HotelsAddComponent } from './hotels-add/hotels-add.component';
import { AuthGuard } from '../../../../../shared/_guards/auth.guard';
import { HotelBrandWizardComponent } from './hotel-brand-wizard/hotel-brand-wizard.component';

const routes: Routes = [
  { path: 'hotel-management', component: HotelBrandComponent, canActivate: [AuthGuard], 
    children: [
      { path: '', pathMatch: 'full', component: HotelsListComponent},
      { path: 'brand/add', pathMatch: 'full', component: HotelBrandAddComponent, canActivate: [AuthGuard]},
      { path: 'hotel/add', pathMatch: 'full', component: HotelsAddComponent, canActivate: [AuthGuard]},
      { path: 'hotel/edit/:id', pathMatch: 'full', component: HotelsAddComponent, canActivate: [AuthGuard]},
      { path: 'brand/wizard', pathMatch: 'full', component: HotelBrandWizardComponent, canActivate: [AuthGuard]},
    ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HotelManagementRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotel-management-routing.module.ts